import React, { Component } from "react";
import moment from "moment";

import SelectBox from "../../../../../../components/select-box/select-box";
import CalendarBox from "../../../../../../components/calendar-box/calendar-box";
import DicotomicButton from "../../../../../../components/dicotomic-button";
import InputBox from "../../../../../../components/input-box/input-box";
import CheckboxItemLayout from "../../../../../../components/checkbox-item/checkbox-item-layout";
import SearchBox from "../../../../../../components/search-box-mediadores/search-box";
import { PersonalInformationContainer } from "./insured-personal-information-style";

import { DOC_NUMBER_MAX_LENGTH } from "../../../../../../constants";
import { withGeneral } from "../../../../../../context/mixin/with-general";
import { validateFormData } from "./insured-personal-information-validations";
import { calcAge, checkDate } from "../../../../../../utils/utility";
import { deepGet } from "../../../../../../utils/utility";
import { filterCountries, getCountriesList } from "../../../../../../utils/countries";
import {
  genderOptions,
  getSelfEmployedDocumentTypes,
  validateStandarisedFieldsHealthHiring,
} from "../../../../../../utils/validation";
import {
  DefaultInsuredPersonalData,
  DefaultProfessionData,
  DefaultValueFormHealth,
  InsuredPersonalDataDto,
} from "./insured-personal-information-dto";
import {
  InsuredPersonalData,
  PersonalInformationProps,
  PersonalInformationState,
} from "./insured-personal-information-types";
import { withPolicy } from "../../../../../../context/mixin/with-policy";
import WASISAServices from "../../../../../../services/WASISAServices";

class PersonalInformation extends Component<PersonalInformationProps, PersonalInformationState> {
  _searchWaiter: any = null;

  constructor(props: PersonalInformationProps) {
    super(props);

    this.state = {
      person: this.getFirstPersonalDataDto(),
      stateDisabled: props.isReadOnly ? props.isReadOnly : false,
      professionsList: [],
      professionsFiltered: [],
      countries: [],
      countriesFiltered: [],
      previousData: DefaultInsuredPersonalData(),
      prevDocType:
        props.insureds && props.insuredIndex > -1 && props.insureds[props.insuredIndex]
          ? props.insureds[props.insuredIndex].docType
          : "",
    };
  }

  getFirstPersonalDataDto = () => {
    const { insureds, insuredIndex, taker } = this.props;
    if (insureds && insuredIndex === 0 && insureds[0] && insureds[0].sameAsTaker) {
      const personalData = { ...insureds[0], ...taker, sameAsTaker: true };
      return this.getPersonalDataDto(personalData, true);
    }
    if (insureds && insuredIndex > -1 && insureds[insuredIndex]) {
      return this.getPersonalDataDto(insureds[insuredIndex], insureds[insuredIndex].sameAsTaker);
    }
    return DefaultInsuredPersonalData();
  }

  getPersonalDataDto(
    personData?: InsuredPersonalData,
    disabled: boolean = false
  ): InsuredPersonalDataDto {
    const countries = this.state && this.state.countries;
    const country =
      personData &&
      personData.nationality &&
      countries &&
      countries.length > 0 &&
      countries.find((country) => country.value === personData.nationality);

    const newPerson =
      !personData || Object.keys(personData).length === 0
        ? DefaultInsuredPersonalData()
        : {
            name: this.getValueFormHealth(personData.name, disabled),
            lastName1: this.getValueFormHealth(personData.lastname1, disabled),
            lastName2: this.getValueFormHealth(personData.lastname2, disabled),
            birthDate: this.getValueFormHealth(
              personData.birthDate ? checkDate(personData.birthDate) : "",
              disabled
            ),
            docType: this.getValueFormHealth(personData.docType, disabled),
            docNumber:
              calcAge(moment(personData.birthDate).format("DD/MM/YYYY")) > 16 &&
              personData.docType === "MENOR"
                ? this.getValueFormHealth("", disabled)
                : this.getValueFormHealth(personData.docNumber, disabled),
            sex: this.getValueFormHealth(personData.gender, disabled),
            nationality: {
              value: personData.nationalityLabel
                ? personData.nationalityLabel
                : country
                ? country.label
                : "",
              errorCode: "",
              disabled: disabled,
              code: personData.nationality ? personData.nationality : country ? country.value : "",
            },
            nationalityLabel: personData.nationalityLabel
              ? personData.nationalityLabel
              : country
              ? country.value
              : "",
            profession: {
              value: personData.profession ? personData.profession.value : "",
              code: personData.profession ? personData.profession.code : "",
              errorCode: "",
              disabled: false,
              other: {
                value:
                  personData.profession &&
                  personData.profession.value === "OTRA" &&
                  personData.profession.other
                    ? personData.profession.other
                    : "",
                errorCode: "",
                disabled: false,
              },
            },
            passportDate: this.getValueFormHealth(
              personData.passportDate ? personData.passportDate : "",
              disabled
            ),
            sameAsTaker: personData.sameAsTaker,
          };

    return newPerson;
  }

  getValueFormHealth(value: string | undefined, disabled: boolean) {
    return {
      value: value ? value : "",
      errorCode: "",
      disabled: disabled,
      code: "",
    };
  }

  getDocTypes(): { [key: string]: string }[] {
    const { person } = this.state;
    const birthDate = person && person.birthDate && person.birthDate.value;
    const nationality = person && person.nationality && person.nationality.value;
    
    let hasUnderAgeOption = false;
    if (birthDate) {
      const age = calcAge(birthDate);
      hasUnderAgeOption = age < 14;
    }
    
    return getSelfEmployedDocumentTypes({ nationality, hasUnderAgeOption, isInsured: true });
  }

  componentWillReceiveProps(nextProps: PersonalInformationProps) {
    let { validate } = this.props;

    if (nextProps.validate.validateRequest) {
      validate.validateRequest = false;
      validate.isValidated = this.validateForm();
    } else if (nextProps.onCleanForm) {
      this.cleanForm();
    } else if (this.props.insuredIndex !== nextProps.insuredIndex) {
      const insuredIndex: number =
        nextProps.insureds && nextProps.insureds.length === 1 ? 0 : nextProps.insuredIndex;
      if (
        nextProps.insuredIndex !== -1 &&
        nextProps.insureds &&
        nextProps.insureds.length > 0 &&
        nextProps.insureds[insuredIndex] &&
        nextProps.insureds[insuredIndex].sameAsTaker
      ) {
        const data = JSON.parse(JSON.stringify(nextProps.taker));
        data.profession = JSON.parse(JSON.stringify(nextProps.insureds[insuredIndex].profession));

        this.completeInsuredData(data, true);
        // Nacionalida
      } else {
        this.completeInsuredData(
          insuredIndex === -1
            ? nextProps.taker
            : nextProps.insureds
            ? nextProps.insureds[insuredIndex]
            : undefined
        );
      }
    }
  }

  async componentDidMount() {
    let { professionsList, countries, person } = this.state;
    const { insuredIndex, insureds, policy } = this.props;

    professionsList = await WASISAServices.getProfessions({
      setLoading: this.props.setLoading,
      businessLine: deepGet(policy, "product.ln_linea_negocio", undefined)
    });

    countries = await getCountriesList(this.props.countries, this.props.setLoading);

    countries.map((country: any) => (country.label = country.label.toUpperCase()));

    let filterProfessions = professionsList
      .sort(function (a: any, b: any) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });

    if (insureds && insuredIndex > -1 && insureds[insuredIndex]) {
      if (insureds[insuredIndex].nationality && !insureds[insuredIndex].nationalityLabel) {
        const country =
          person.nationality &&
          countries.length > 0 &&
          countries.find((country) => country.value === insureds[insuredIndex].nationality);
        person.nationality = {
          value: country ? country.label : "",
          errorCode: "",
          disabled: insureds[insuredIndex].sameAsTaker,
          code: person.nationality ? person.nationality : country ? country.value : "",
        };
        person.nationalityLabel = country ? country.label : "";
        this.setState({ person });
      }
    }

    this.setState({ professionsList: filterProfessions, countries });
  }

  handleValueChange(input: string, value: any) {
    let { person, prevDocType } = this.state;
    const { taker } = this.props;
    if (
      !(input === "sex" && taker && value === taker.gender) &&
      !(input === "docType" && taker && value === taker.docType)
    ) {
      this.props.onAnyChange();
    }

    switch (input) {
      case "name":
      case "lastName1":
      case "lastName2":
      case "birthDate":
      case "docNumber":
      case "sex":
      case "docType":
      case "passportDate":
        value = typeof value === "string" ? value.toUpperCase() : value;
        Object.keys(person).forEach((k: string) => {
          if (k === input) {
            person[k].errorCode = "";
            person[k].value = value;

            const isOnChangeEvent = true;
            validateStandarisedFieldsHealthHiring(value, input, isOnChangeEvent, person);

            if (input === "docType") {
              person.docNumber.disabled = value === "MENOR" ? true : person.docNumber.disabled;
              person.docNumber =
                person.docNumber.disabled && value === "MENOR"
                  ? this.getValueFormHealth(undefined, true)
                  : value !== "MENOR" && prevDocType === "MENOR"
                  ? this.getValueFormHealth(undefined, false)
                  : person.docNumber;
              prevDocType = value;
            }

            if (input === "birthDate") {
              let age = calcAge(value);
              prevDocType = person.docType.value;
              if (!isNaN(age) && age > 17) {
                person.docNumber.disabled = person.docType.value === "MENOR";
              }
            }
          }
        });
        break;

      case "profession":
        person.profession.value = value.label;
        person.profession.code = value.value;
        person.profession.errorCode = "";
        break;

      case "otherProfession":
        value = value.toUpperCase();
        person.profession.other.value = value;
        person.profession.other.errorCode = "";
        break;

      case "nationality":
        person.nationality.value = value.label;
        person.nationality.code = value.value;
        person.nationality.errorCode = "";
        person.nationalityLabel = value.label;
        if (value.value !== "ESPA" && person.lastName2.errorCode === 'required') {
          person.lastName2.errorCode = "";
        }
        break;

      default:
        break;
    }

    this.setState({ person, prevDocType });
  }

  validateForm(): boolean {
    const { person } = this.state;
    const { insureds, insuredIndex, taker } = this.props;
    const { noErrors, newPerson } = validateFormData({ person, insureds, insuredIndex, taker });

    if (noErrors) {
      if (this.props.onValidated) {
        if (person.docType.value === "MENOR" && !person.docNumber.value && this.props.insureds) {
          let minorSequencial = 0;
          this.props.insureds.map((insured: any) => {
            if (insured.docType === "MENOR" && insured.docNumber.length < 2) {
              if (insured.docNumber > minorSequencial) {
                minorSequencial = insured.docNumber;
              }
            }
          });
          person.docNumber.value = String(Number(minorSequencial) + 1);
          person.docNumber.disabled = true;
        }

        this.props.onValidated({
          name: person.name.value,
          lastname1: person.lastName1.value,
          lastname2: person.lastName2.value,
          birthDate: person.birthDate.value,
          docType: person.docType.value,

          docNumber: person.docNumber.value,
          passportDate: person.passportDate.value,
          gender: person.sex.value,
          nationality:
            typeof person.nationality.code === "string"
              ? person.nationality.code
              : deepGet(person, "nationality.code.code", ""),
          nationalityLabel: person.nationality.value,

          profession: {
            value: person.profession.value,
            code: person.profession.code,
            other: person.profession.other.value,
          },
          sameAsTaker: person.sameAsTaker,
        });
      }
    }

    this.setState({ person: newPerson });
    return noErrors;
  }

  cleanForm() {
    this.setState({
      person: DefaultInsuredPersonalData(),
      stateDisabled: false,
      previousData: DefaultInsuredPersonalData(),
      countriesFiltered: this.state.countries,
      professionsFiltered: this.state.professionsList,
    });
  }

  completeInsuredData(personData?: InsuredPersonalData, isTakerData: boolean = false) {
    let { person, prevDocType } = this.state;
    person = this.getPersonalDataDto(
      personData,
      personData ? (personData.sameAsTaker ? personData.sameAsTaker : isTakerData) : false
    );

    if (isTakerData) {
      person.sameAsTaker = isTakerData;
    }

    prevDocType = person.docType.value;

    this.setState({ person, prevDocType });
  }

  completeFormTakerData(person: InsuredPersonalDataDto) {
    let getPreviousData = (person: InsuredPersonalDataDto) => {
      const previousData: InsuredPersonalDataDto = JSON.parse(JSON.stringify(person));
      previousData.birthDate.errorCode = "";
      previousData.name.errorCode = "";
      previousData.lastName1.errorCode = "";
      previousData.lastName2.errorCode = "";
      previousData.birthDate.errorCode = "";
      previousData.docNumber.errorCode = "";
      previousData.docType.errorCode = "";
      previousData.sex.errorCode = "";
      previousData.nationality.errorCode = "";
      previousData.profession.errorCode = "";
      previousData.profession.other.errorCode = "";
      previousData.passportDate.errorCode = "";
      return previousData;
    };
    let { taker } = this.props;
    let { prevDocType } = this.state;

    let previousData = getPreviousData(person);
    if (taker) {
      if (!this.props.insured) {
        this.props.handlePersonChange();
      }

      person = this.getPersonalDataDto(taker, this.props.insured ? this.props.insured : false);
      person.sameAsTaker = true;

 
      prevDocType = person.docType.value;

      this.setState({ person: person, previousData, prevDocType });
    }
  }

  handleCheckTakerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let { person } = this.state;

    person.sameAsTaker = !person.sameAsTaker;
    this.props.onCheckTakerData(person.sameAsTaker);

    if (person.sameAsTaker) {
      this.completeFormTakerData(person);
    } else {
      this.getPreviousData(person);
    }
  };

  getPreviousData(person: InsuredPersonalDataDto) {
    let { previousData, prevDocType } = this.state;

    person.name = previousData.name;
    person.lastName1 = previousData.lastName1;
    person.lastName2 = previousData.lastName2;
    person.birthDate = previousData.birthDate;
    person.docType = previousData.docType;
    person.docNumber = previousData.docNumber;
    person.sex = previousData.sex;
    person.nationality = previousData.nationality;
    person.profession = previousData.profession;
    person.passportDate = previousData.passportDate;

    previousData = DefaultInsuredPersonalData();

    prevDocType = person.docType.value;

    this.setState({ previousData, person, prevDocType });
  }

  changeValueSearchBox(ev: any, arg1: string, arg2: string) {
    if (this._searchWaiter) {
      clearInterval(this._searchWaiter);
    }
    const { person } = this.state;
    const value: string = ev.target.value;

    // Reset searchBox values to default if delete prev data
    if (value.length < 1) {
      if (this.state.person.hasOwnProperty(arg2) && arg2 === "profession") {
        person.profession = DefaultProfessionData();
      }
      if (this.state.person.hasOwnProperty(arg2) && arg2 === "nationality") {
        person.nationality = DefaultValueFormHealth();
        person.nationalityLabel = "";
      }
      this.setState({ person });
    }

    if (value.length < 2) return;

    if (value.length >= 2) {
      switch (arg2) {
        case "profession":
          this.setState({
            professionsFiltered: this.state.professionsList.filter((prefession) =>
              prefession.label
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                  value
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                )
            ),
          });
          break;
        case "nationality":
          this.setState({
            countriesFiltered: filterCountries(value, this.state.countries),
          });
          break;

        default:
          break;
      }
    }
  }

  isFirstInsured = (): boolean =>
    this.props.insuredIndex === 0 ||
    (this.props.insuredIndex === -1 && (!this.props.insureds || this.props.insureds.length === 0));

  showCheckSameAsTaker = () => {
    if (this.props.taker && this.props.taker.physicalPerson && this.isFirstInsured()) {
      return true;
    }
    return false;
  };

  render() {
    const { person, countriesFiltered, professionsFiltered } = this.state;
    const { isReadOnly } = this.props;

    return (
      <PersonalInformationContainer>
        <div className="content-wrapper bottomMargin20" ref={""}>
          <div className="personal-data-wrapper">
            <div className="data-title" id="data-personal">
              <h5>DATOS PERSONALES</h5>
            </div>
            <div className="personal-data-row">
              <div className="personal-data-item col-50">
                {this.showCheckSameAsTaker() && (
                  <div className="bottomMargin20">
                    <CheckboxItemLayout
                      name="Los datos personales son los mismos que los del tomador"
                      checked={person.sameAsTaker}
                      onChange={this.handleCheckTakerChange}
                      showError={false}
                      checkboxText="El tomador de la póliza es el asegurado"
                      errorText="Error"
                      disabled={isReadOnly}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="personal-data-fisica">
              <div className="personal-data-row">
                <div className="personal-data-item col-50">
                  <div className="inputBox">
                    <InputBox
                      placeholder="Nombre"
                      required={true}
                      errorCode={person.name.errorCode}
                      disabled={person.name.disabled || isReadOnly}
                      value={person.name.value}
                      onChange={(value: string) => this.handleValueChange("name", value)}
                    />
                  </div>
                </div>

                <div className="personal-data-item col-50">
                  <div className="inputBox">
                    <InputBox
                      placeholder="Apellido 1"
                      required={true}
                      errorCode={person.lastName1.errorCode}
                      disabled={person.lastName1.disabled || isReadOnly}
                      value={person.lastName1.value}
                      onChange={(value: string) => this.handleValueChange("lastName1", value)}
                    />
                  </div>
                </div>
              </div>

              <div className="personal-data-row">
                <div className="personal-data-item col-50">
                  <div className="inputBox">
                    <InputBox
                      placeholder="Apellido 2"
                      required={person.nationality && person.nationality.code === "ESPA"}
                      errorCode={person.lastName2.errorCode}
                      disabled={person.lastName2.disabled || isReadOnly}
                      value={person.lastName2.value}
                      onChange={(value: string) => this.handleValueChange("lastName2", value)}
                      type={"letters"}
                    />
                  </div>
                </div>

                <div className="personal-data-item col-50">
                  <div className="inputBox">
                    <CalendarBox
                      initialValue={person.birthDate.value}
                      placeholder="Fecha de nacimiento"
                      forbidFutureDates
                      minAge={this.props.insured ? 0 : 18}
                      maxDate={moment().toISOString()}
                      required={true}
                      disabled={person.birthDate.disabled || isReadOnly}
                      errorCode={person.birthDate.errorCode}
                      onChange={(value: string) => this.handleValueChange("birthDate", value)}
                      health={true}
                    />
                  </div>
                </div>
              </div>

              <div className="personal-data-row">
                <div className="personal-data-item col-50">
                  <div className="personal-data-item col-25">
                    <DicotomicButton
                      required={true}
                      labelText="Sexo"
                      options={genderOptions}
                      withTab={true}
                      disabled={person.sex.disabled || isReadOnly}
                      initialValue={person.sex.value}
                      onChange={(value: string) => this.handleValueChange("sex", value)}
                      errorCode={person.sex.errorCode}
                    />
                  </div>
                </div>
                <div className="personal-data-item col-50">
                  <div className="inputBox">
                    <SearchBox
                      onChange={(ev: any) =>
                        this.changeValueSearchBox(ev, "contact", "nationality")
                      }
                      labelText=""
                      optionsText={countriesFiltered}
                      optionKey={"value"}
                      optionValue={"label"}
                      disabled={person.nationality.disabled || isReadOnly}
                      initialValue={person.nationality.value}
                      required={true}
                      errorCode={person.nationality.errorCode}
                      onSelect={(value: any) => this.handleValueChange("nationality", value)}
                    />
                    <label>Nacionalidad</label>
                  </div>
                </div>
              </div>

              <div className="personal-data-container">
                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="selectBox">
                      <SelectBox
                        placeholder="Documento de identidad"
                        required={true}
                        errorCode={person.docType.errorCode}
                        optionsText={this.getDocTypes()}
                        optionKey={"value"}
                        optionValue={"label"}
                        initialValue={person.docType.value}
                        defaultValue={person.docType.value}
                        disabled={person.docType.disabled || isReadOnly}
                        onChange={(value: string) => this.handleValueChange("docType", value)}
                      />
                      <label>{"Documento de identidad"}</label>
                    </div>
                  </div>
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="Nº de documento"
                        required={person.docType.value !== "MENOR"}
                        errorCode={person.docNumber.errorCode}
                        maxLength={DOC_NUMBER_MAX_LENGTH}
                        value={person.docType.value !== "MENOR" ? person.docNumber.value : ""}
                        disabled={
                          person.docNumber.disabled ||
                          person.docType.value === "MENOR" ||
                          isReadOnly
                        }
                        onChange={(value: string) => this.handleValueChange("docNumber", value)}
                        type={
                          person.docType.value === "NIF"
                            ? "NIF"
                            : person.docType.value === "NIE"
                            ? "NIE"
                            : person.docType.value === "PAS"
                            ? "PAS"
                            : "NIF"
                        }
                      />
                    </div>
                  </div>

                  {person.docType.value === "PAS" && (
                    <div className="personal-data-item col-50">
                      <div className="inputBox">
                        <CalendarBox
                          initialValue={person.passportDate.value}
                          placeholder="Fecha de caducidad del pasaporte"
                          minDate={moment().toISOString()}
                          required={true}
                          disabled={person.passportDate.disabled || isReadOnly}
                          errorCode={person.passportDate.errorCode}
                          onChange={(value: string) =>
                            this.handleValueChange("passportDate", value)
                          }
                          health={true}
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="selectBox">
                      <SearchBox
                        onChange={(ev: any) =>
                          this.changeValueSearchBox(ev, "occupation", "profession")
                        }
                        labelText=""
                        required={false}
                        errorCode={person.profession.errorCode}
                        optionsText={professionsFiltered}
                        optionKey={"value"}
                        optionValue={"label"}
                        initialValue={person.profession.value}
                        onSelect={(value: any) => this.handleValueChange("profession", value)}
                        disabled={person.profession.disabled || isReadOnly}
                      />
                      <label>{"Profesión"}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PersonalInformationContainer>
    );
  }
}

export default withGeneral(withPolicy(PersonalInformation));
